import { graphql, useStaticQuery } from 'gatsby'

export type Author = {
  id: string
  userProfile: {
    jobTitle: string
    fullName: string
    linkedin: string
    slug: string
    miniBlurb: string
  }
}

export type AuthorNode = {
  node: Author
}

export const getBlogAuthorsAndReviewers = (): AuthorNode[] => {
  const data = useStaticQuery(graphql`
    query authors {
      allWpUser(filter: { userProfile: { jobTitle: { ne: null } } }) {
        edges {
          node {
            id
            userProfile {
              jobTitle
              fullName
              linkedin
              slug
              miniBlurb
            }
          }
        }
      }
    }
  `)
  return data.allWpUser.edges
}
